import { IPermissionsConfig } from '@/store/modules/main/intefaces/IConfig'
import { permissionSchema } from '@/store/modules/users/interfaces/IUser'

export function getValueByLabel (permissions : IPermissionsConfig[], key : string): boolean {
  if (permissions.length) {
    if (key === 'Home Page' || key === 'Pub Menu' || key === 'Product Recommendation' || key === 'My Documents' ||
       key === 'Empties Management'
    ) {
      return true
    }
    for (let i = 0; i < permissions.length; i++) {
      if (permissions[i].label === key && permissions[i].value === '1') {
        return true
      }
    }
  }
  return false
}
export function checkPermission (userPermission: string[], globalPermission: IPermissionsConfig[], permission: string, value: Record<string, any>, additionalPremmision = true) {
  return userPermission?.includes(permission) &&
    additionalPremmision &&
    getValueByLabel(globalPermission, permission)
    ? [value]
    : []
}

export function hasPermission (allAvailablePermission: string[], globalPermission: IPermissionsConfig[], permission: string) {
  return !!(!!allAvailablePermission?.includes(permission) &&
  getValueByLabel(globalPermission, permission))
}

export function isOutletUser (permissions: permissionSchema[]) {
  const shipToIdFromStorage = localStorage.getItem('shipToId')
  return permissions?.some((company) =>
    company.shipToId === shipToIdFromStorage &&
    company.rpDetails?.some((rp) => rp.customerType === 'Outlets')
  )
}

export function isOutletCustomer (permissions: permissionSchema[]) {
  return permissions?.some((company) =>
    company.rpDetails?.some((rp) => rp.customerType === 'Outlets')
  )
}

export function isOnPremiseEmptiesUser (permissions: permissionSchema[]) {
  const shipToIdFromStorage = localStorage.getItem('shipToId')
  return permissions.some((company) =>
    company.shipToId === shipToIdFromStorage &&
    company.rpDetails?.some((rp) => rp.rolename === 'On Premise Empties Management')
  )
}

export function isOnPremiseFranchiseEmptiesUser (permissions: permissionSchema[]) {
  const shipToIdFromStorage = localStorage.getItem('shipToId')
  return permissions?.some((company) =>
    company.shipToId === shipToIdFromStorage &&
    company.rpDetails?.some((rp) => rp.rolename === 'On Premise Franchisee Empties Management')
  )
}
